
<template>
    <div class="IPLicenseDetails">
        <div class="topNav">
            <img class="img" src="../../../../viewsGangAn/assets/index.png" alt="">
            <div class="r">></div>
            <div class="text" @click="onUrl('/memberInfo')">个人中心</div>
            <div class="r">></div>
            <div class="text" @click="onUrl('/IPLicense')">IP授权申请</div>
            <div class="r">></div>
            <div class="text active">订单详情</div>
        </div>
        <div class="container">
            <div class="blockOne">
                <div class="myTitle">订单详情</div>
                <div class="infoBox">
                    <div class="left">
                        <div class="fuwu">申请名称：{{ipData.title}}</div>
                        <div class="time">申请编号：{{ipData.order_num}}</div>
                        <div class="time">创建时间：{{ipData.created_at}}</div>
                    </div>
                    <div class="right" v-if="ipData.status == 0">
                        <img class="img" src="../../../../viewsGangAn/assets/qxsqS.png" alt="">
                        <div class="text">申请中</div>
                    </div>
                    <div class="right" v-if="ipData.status == 3">
                        <img class="img" src="../../../../viewsGangAn/assets/qxsq.png" alt="">
                        <div class="text">取消申请</div>
                    </div>
                    <div class="right" v-if="ipData.status == 2">
                        <img class="img" src="../../../../viewsGangAn/assets/qxsqW.png" alt="">
                        <div class="text">已完成</div>
                    </div>
                </div>
            </div>
            <div class="blockOne">
                <div class="myTitle">权益详情</div>
                <div class="listBox" v-for="(item,index) in ipDataHtml" :key="index">
                    <img class="img" :src="item.icon" alt="">
                    <div class="list">
                        <div class="title">{{item.title}}</div>
                        <div class="item" v-for="(itemC,indexC) in item.son" :key="indexC">
                            <div class="itemC">{{itemC.title}}</div>
                            <div class="itemCC" v-if="itemC.description.length > 0" v-html="itemC.description.replace(/\n/gm,'<br/>')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {userOrderDetail} from "@/api/ipAuth.js";
import Cookies from "js-cookie";
export default {
    metaInfo: {
        title: 'IP授权详情|前海版权综合服务平台',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        }, {
            name: 'Description',
            content: 'IP授权详情,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
    },
    name: "IPLicenseDetails",
    data() {
        return {
            ipData: {},
            ipDataHtml: []
        }
    },
    created() {
        this.userOrderDetail()
    },
    methods: {
        onUrl(url) {
            this.$router.push(url)
        },
        userOrderDetail() {
            let that = this
            let accessUuid = Cookies.get("userInfoIP") == undefined || Cookies.get("userInfoIP") == 'undefined' || Cookies.get("userInfoIP") == null || Cookies.get("userInfoIP") == ''?'':JSON.parse(Cookies.get("userInfoIP")).uuid
            let data = {
                uuid: this.$route.query.id,
                action_id: this.$route.query.ip_uuid,
                platform: "PC",
                user_id: accessUuid
            }
            userOrderDetail(data).then(res => {
                that.ipData = res.data
                that.ipDataHtml = JSON.parse(res.data.content)
                console.log(JSON.parse(res.data.content));
            })
        }
    }
}
</script>
<style>
.IPLicenseDetails{
    background: #F4F8FC;
}
</style>
<style scoped lang="less">
.topNav{
    display: flex;
    align-items: center;
    width: 1200px;
    margin: auto;
    padding: 18px 0;
    font-size: 14px;
    color:#999999;
    .img{
        width: 16px;
        height: 16px;
    }
    .r{
        margin: 0 10px;
    }
    .active{
        color: #2196F3;
    }
    .text{
        cursor: pointer;
    }
}
.container{
    width: 1200px;
    padding-bottom: 30px;
    margin: auto;
    .blockOne{
        background: #fff;
        border-radius: 12px;
        padding: 40px 30px;
        margin-bottom: 20px;
        .myTitle{
            font-size: 18px !important;
            font-weight: 700;
            position: relative;
            z-index: 2;
            font-family: 'AlibabaPuHuiTi';
            color: #333;
            &::before{
                content: '';
                position: absolute;
                width: 50px;
                background: #2196F3;
                height: 6px;
                border-radius: 3px;
                left: 0;
                bottom: 3px;
                z-index: -1;
            }
        }
        .infoBox{
            display: flex;
            align-items: center;
            .left{
                flex: 1;
                .fuwu{
                    font-weight: 700;
                    font-size: 16px;
                    margin-top: 27px;
                    margin-bottom: 8px;
                    font-family: 'AlibabaPuHuiTi';
                    color: #333;
                }
                .time{
                    font-size: 14px;
                    color: #666666;
                    margin-top: 4px;
                }
            }
            .right{
                .img{
                    width: 40px;
                    height: 40px;
                    margin: auto;
                }
                .text{
                    font-weight: 700;
                    font-size: 18px;
                    margin-top: 10px;
                    font-family: 'AlibabaPuHuiTi';
                    color: #333;
                }
            }
        }
        .listBox{
            display: flex;
            margin-top: 29px;
            .img{
                width: 26px;
                height: 26px;
            }
            .list{
                margin-left: 10px;
                border-bottom: solid 1px #F5F5F5;
                padding-bottom: 15px;
                .title{
                    font-size: 16px !important;
                    font-weight: 700;
                    font-family: 'AlibabaPuHuiTi';
                    color: #333;
                    margin-top: 2px;
                    margin-bottom: 12px;
                }
                .item{
                    color: #333333;
                    font-size: 14px;
                    margin-bottom: 8px;
                    position: relative;

                    line-height: 1.6;
                    .itemC{
                        position: relative;
                        padding-left: 13px;
                        &::after{
                            content: '';
                            position: absolute;
                            width: 5px;
                            height: 5px;
                            background: #2196F3;
                            border-radius: 100%;
                            top: 50%;
                            transform: translate(0,-50%);
                            left: 0;
                        }
                    }
                    .itemCC{
                        padding-left: 13px;
                    }

                }
            }
        }
    }
}

</style>
